module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jQuery","commonjs2":"jQuery","amd":"jQuery","root":"$"}
// module id = 3
// module chunks = 0